/**
 * @generated SignedSource<<b59d6a239eab941045419d05198bf04e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemLiveArticleContentArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent" | "contentShareWidgetContent">;
  readonly " $fragmentType": "itemLiveArticleContentArticle";
};
export type itemLiveArticleContentArticle$key = {
  readonly " $data"?: itemLiveArticleContentArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemLiveArticleContentArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemLiveArticleContentArticle",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentShareWidgetContent"
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "f4d6667fc0ac28017cc1845ae144ffe7";

export default node;
